import { render } from "./ProjectList.vue?vue&type=template&id=138b8af2&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=138b8af2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-138b8af2"

export default script